import type { ComponentType } from 'react'

import { ConsumoHosteleriaPresupuestoArticle } from '@/features/actualidad-hostelera/ConsumoHosteleriaPresupuestoArticle'
import { DigitalizacionBoeTribunaArticle } from '@/features/actualidad-hostelera/DigitalizacionBoeTribunaArticle'
import { DigitalizacionHosteleriaArticle } from '@/features/actualidad-hostelera/DigitalizacionHosteleriaArticle'
import { HacemosCocinaTipiArticle } from '@/features/actualidad-hostelera/HacemosCocinaTipiArticle'
import { IaHosteleriaIneArticle } from '@/features/actualidad-hostelera/IaHosteleriaIneArticle'
import { LuzIndexadaOFijaArticle } from '@/features/actualidad-hostelera/LuzIndexadaOFijaArticle'
import { MejorHerramientaHosteleriaArticle } from '@/features/actualidad-hostelera/MejorHerramientaHosteleriaArticle'
import { MovilHosteleriaFaltaLeveArticle } from '@/features/actualidad-hostelera/MovilHosteleriaFaltaLeveArticle'
import { OrmuzSubidaPreciosArticle } from '@/features/actualidad-hostelera/OrmuzSubidaPreciosArticle'
import { PlanChoqueFrigoArticle } from '@/features/actualidad-hostelera/PlanChoqueFrigoArticle'
import { PrecioDinamicoCosteArticle } from '@/features/actualidad-hostelera/PrecioDinamicoCosteArticle'
import { ProhibicionFumarTerrazasArticle } from '@/features/actualidad-hostelera/ProhibicionFumarTerrazasArticle'
import { RentabilidadHosteleriaArticle } from '@/features/actualidad-hostelera/RentabilidadHosteleriaArticle'
import { SddrHosteleriaArticle } from '@/features/actualidad-hostelera/SddrHosteleriaArticle'
import { TuristaGastaMenosArticle } from '@/features/actualidad-hostelera/TuristaGastaMenosArticle'
import { VerifactuRetrasoArticle } from '@/features/actualidad-hostelera/VerifactuRetrasoArticle'
import {
    NEWS_ARTICLES,
    type NewsArticleBodyProps,
    type NewsArticleDefinition,
    localizeNewsArticle,
} from '@/features/actualidad-hostelera/articles'
import type { LandingLocale } from '@/navigation/localeConstants'

const NEWS_ARTICLE_BODIES: Record<string, ComponentType<NewsArticleBodyProps>> = {
    'hacemos-cocina-guia-repsol-tipi': HacemosCocinaTipiArticle,
    'ia-hosteleria-ine-2026': IaHosteleriaIneArticle,
    'verifactu-retraso-2028-hosteleria': VerifactuRetrasoArticle,
    'luz-indexada-o-fija-restaurante': LuzIndexadaOFijaArticle,
    'digitalizacion-hosteleria-la-empuja-el-boe': DigitalizacionBoeTribunaArticle,
    'movil-hosteleria-falta-leve-boe': MovilHosteleriaFaltaLeveArticle,
    'sddr-hosteleria-deposito-envases-2026': SddrHosteleriaArticle,
    'consumo-hosteleria-presupuesto-hogares-2026': ConsumoHosteleriaPresupuestoArticle,
    'turista-gasta-menos-restaurantes-2026': TuristaGastaMenosArticle,
    'prohibicion-fumar-terrazas-quien-decide-hosteleria-espana': ProhibicionFumarTerrazasArticle,
    'rentabilidad-hosteleria-20-anos': RentabilidadHosteleriaArticle,
    'por-que-hosteleria-tarda-digitalizarse-control-costes': DigitalizacionHosteleriaArticle,
    'precio-dinamico-restaurantes-coste-vs-demanda': PrecioDinamicoCosteArticle,
    'mejor-herramienta-hosteleria-independiente-2026': MejorHerramientaHosteleriaArticle,
    'ormuz-subida-precios-hosteleria-otono-2026': OrmuzSubidaPreciosArticle,
    'el-gobierno-te-paga-el-frigo-nuevo': PlanChoqueFrigoArticle,
}

export function listRoutableNewsArticles(locale: LandingLocale = 'es') {
    return NEWS_ARTICLES.filter(article => NEWS_ARTICLE_BODIES[article.id])
        .map(article => localizeNewsArticle(article, locale))
        .sort((a, b) => b.publishedAt.localeCompare(a.publishedAt))
}

export function listRoutableNewsArticleDefinitions(): NewsArticleDefinition[] {
    return NEWS_ARTICLES.filter(article => NEWS_ARTICLE_BODIES[article.id]).sort((a, b) =>
        b.publishedAt.localeCompare(a.publishedAt),
    )
}

export function getNewsArticleBody(id: string) {
    return NEWS_ARTICLE_BODIES[id]
}
